import PropTypes from "prop-types";

const IconChatbotStroke = ({
	useGradient = false,
	gradientId = "ai-gradient-chatbot",
	...props
}) => (
	<svg viewBox="0 0 25 25" {...props}>
		{useGradient && (
			<defs>
				<linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
					<stop offset="2.69%" stopColor="var(--ai-gradient-start)" />
					<stop offset="95.47%" stopColor="var(--ai-gradient-end)" />
				</linearGradient>
			</defs>
		)}
		<path
			fill={useGradient ? `url(#${gradientId})` : "currentColor"}
			d="M13.986 1.753c.216.003.39.008.551.02 4.625.318 8.307 3.963 8.628 8.544.022.319.021.769.021 1.424 0 .656.001 1.027-.021 1.345l-.026.304a9.12 9.12 0 0 1-1.489 4.129l1.462 3.607c.11.27.05.578-.151.79l-.08.072a.76.76 0 0 1-.708.123l-4.197-1.392a9.345 9.345 0 0 1-3.99.931l-.805.003h-1.587l-.807-.003a9.913 9.913 0 0 1-.55-.02c-4.48-.307-8.075-3.739-8.588-8.117l-.04-.427c-.022-.319-.022-.69-.022-1.345s0-1.105.022-1.424c.322-4.58 4.002-8.226 8.627-8.545a9.89 9.89 0 0 1 .551-.02l.807-.002h1.587l.805.003ZM11.594 3.25c-.683 0-.996 0-1.254.019-3.89.267-6.966 3.33-7.235 7.154-.017.253-.018.637-.018 1.318 0 .678 0 .986.018 1.24.269 3.823 3.345 6.886 7.235 7.154.258.017.57.018 1.254.018h1.587c.683 0 .996 0 1.254-.018a7.844 7.844 0 0 0 2.886-.766l.548-.265.58.19 2.66.884-.848-2.096-.3-.735.441-.66a7.622 7.622 0 0 0 1.266-3.707c.018-.253.018-.56.018-1.239 0-.681 0-1.065-.018-1.318-.268-3.824-3.344-6.887-7.233-7.154-.258-.018-.571-.019-1.254-.019h-1.587Zm.794 3.95a.6.6 0 0 1 .592.506l.037.234a4.174 4.174 0 0 0 3.64 3.497.601.601 0 0 1 0 1.192 4.188 4.188 0 0 0-3.65 3.497l-.027.169a.6.6 0 0 1-1.185 0l-.025-.166a4.192 4.192 0 0 0-3.653-3.5.6.6 0 0 1 0-1.191 4.177 4.177 0 0 0 3.642-3.5l.036-.232.027-.105a.6.6 0 0 1 .566-.4Z"
		/>
	</svg>
);

IconChatbotStroke.propTypes = {
	useGradient: PropTypes.bool,
	gradientId: PropTypes.string,
};

export default IconChatbotStroke;
